import React, { useId, useState } from 'react';
import { CheckIcon, ChevronDownIcon, XIcon } from 'lucide-react';
interface MultiSelectFilterProps {
  label: string;
  options: string[];
  selected: string[];
  onChange: (values: string[]) => void;
  emptyLabel: string;
}
export function MultiSelectFilter({
  label,
  options,
  selected,
  onChange,
  emptyLabel
}: MultiSelectFilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const listId = useId();
  const selectedCount = selected.length;
  const buttonLabel = selectedCount === 0 ? emptyLabel : `${selectedCount} selected`;
  const toggleOption = (option: string) => {
    onChange(selected.includes(option) ? selected.filter(value => value !== option) : [...selected, option]);
  };
  return <div className="relative" data-id="element-133" data-mp="2wfs1h4rz6te0">
      <button type="button" onClick={() => setIsOpen(open => !open)} aria-expanded={isOpen} aria-haspopup="dialog" aria-controls={listId} className={`inline-flex min-w-[172px] items-center justify-between gap-3 border px-3 py-2.5 text-left text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#009EDB] ${selectedCount > 0 ? 'border-[#009EDB] bg-[#F4F9FD] text-[#0B1856] dark:bg-[#009EDB]/10 dark:text-white' : 'border-[#D7DDEA] bg-white text-gray-700 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200'}`} data-id="element-134" data-mp="zlowipb0wfk1">
        <span className="truncate" data-id="element-135" data-mp="22c2gcvum1nys">{buttonLabel}</span>
        <ChevronDownIcon className={`h-4 w-4 flex-shrink-0 text-[#009EDB] transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-136" data-mp="22clxwbgcmaca" />
      </button>

      {isOpen && <div id={listId} role="dialog" aria-label={`${label} filter options`} className="absolute left-0 z-30 mt-2 w-64 border border-[#D7DDEA] bg-white p-2 shadow-lg dark:border-gray-600 dark:bg-gray-800" data-id="element-137" data-mp="1sjwn7ismh0i0">
          <div className="flex items-center justify-between border-b border-[#E4E8F0] px-2 pb-2 dark:border-gray-700" data-id="element-138" data-mp="2q2g96ol0rquf">
            <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#0B1856] dark:text-gray-200" data-id="element-139" data-mp="2zwv9skw6htme">
              {label}
            </p>
            {selectedCount > 0 && <button type="button" onClick={() => onChange([])} className="inline-flex items-center gap-1 text-xs font-semibold text-[#009EDB] hover:text-[#0B1856] dark:hover:text-white" data-id="element-140" data-mp="2pxw9pqphb6b0">
                <XIcon className="h-3.5 w-3.5" data-id="element-141" data-mp="2c7sv9lwucgw4" />
                Clear
              </button>}
          </div>
          <div className="mt-1 max-h-52 overflow-y-auto py-1 custom-scrollbar" data-id="element-142" data-mp="2786e51dw6gi1">
            {options.map(option => {
          const isSelected = selected.includes(option);
          return <label key={option} className="flex cursor-pointer items-center gap-2 px-2 py-2 text-sm text-[#0B1856] hover:bg-[#F4F9FD] dark:text-gray-100 dark:hover:bg-gray-700" data-id="element-143" data-mp="1xas2rg6tshwl">
                  <span className={`flex h-4 w-4 items-center justify-center border ${isSelected ? 'border-[#009EDB] bg-[#009EDB]' : 'border-[#AEB9CA] bg-white dark:border-gray-500 dark:bg-gray-800'}`} aria-hidden="true" data-id="element-144" data-mp="8qmjgmf4ykip">
                    {isSelected && <CheckIcon className="h-3 w-3 text-white" data-id="element-145" data-mp="mpvyvjvipalm" />}
                  </span>
                  <input type="checkbox" className="sr-only" checked={isSelected} onChange={() => toggleOption(option)} data-id="element-146" data-mp="3l9vu9qy2dk9a" />
                  <span className="truncate" data-id="element-147" data-mp="3v4e0b2qydrw9">{option}</span>
                </label>;
        })}
          </div>
        </div>}
    </div>;
}